import axios from 'axios';
import { API_URL } from 'config.js';

import { store } from 'store.js';
import { caricamento, aggiornaMessaggi, aggiornaPadre, chiudiModaleRisposta } from 'features/99/conversazioni/conversazioniSlice';

const API_MESSAGGI_URL = `${API_URL}/99/ticket/`;
const API_RISPOSTA_URL = `${API_URL}/99/crea_o_rispondi_ticket/`;

function getCredenziali() {
  const {
    auth: {
      currentUser: { pin, utente },
    },
  } = store.getState();

  return [utente, pin];
}

async function richiediDati(idTicket) {
  // check if idTicket exsists
  if (!idTicket) {
    return false;
  }

  // show loading
  store.dispatch(caricamento(true));

  // get credentials
  const [utente, pin] = getCredenziali();

  // make request
  const response = await axios.post(API_MESSAGGI_URL, {
    utente,
    pin,
    idTicket,
  });

  // get messaggi from response if successo is true
  if (response?.data?.successo) {
    const {
      dati: { messaggi },
      padre,
    } = response.data;
    store.dispatch(aggiornaMessaggi(messaggi));
    store.dispatch(aggiornaPadre(padre));
  } else if (response?.data?.errore) {
    alert(response.data.errore);
  }

  store.dispatch(caricamento(false));

  return true;
}

async function rispondi(id) {
  // get credentials
  const [utente, pin] = getCredenziali();

  // get messaggio da inviare
  const {
    conversazioni99: { messaggioDaInviare },
  } = store.getState();

  // check if messaggioDaInviare is not empty
  if (!messaggioDaInviare || messaggioDaInviare.trim() === '' || messaggioDaInviare.length > 500) {
    alert('Inserisci un messaggio valido');
    return false;
  }

  // set loading state
  store.dispatch(caricamento(true));

  // make request
  const response = await axios.post(API_RISPOSTA_URL, { utente, pin, idTicket: id, risposta: messaggioDaInviare.trim() });

  // check if response is success
  if (response?.data?.successo) {
    // stop loading and close modal
    store.dispatch(chiudiModaleRisposta());

    // reload data
    await richiediDati(id);
    return true;
  }

  store.dispatch(chiudiModaleRisposta());
  alert(response.data.errore);
  richiediDati(id);
  return false;
}

export { richiediDati, rispondi };
